import { CATALOG_ID, LANG_ID, STORE_ID } from '@/scripts/constants/parameters'
import { OPTICAL, STD } from '@/scripts/constants/pdp'
import { SHOP_CART, WISHLIST_VIEW } from '@/scripts/constants/pages'
import {
  TRACKER_CHECKOUT_STEP_GATEWAY,
  TRACKER_ERROR_SOURCE_SERVER,
  TRACKER_PRODS_CHANGE_UPC,
  TRACK_MINI_CART_OVERLAY_OPEN,
} from '../../constants/tracker'
import { WCS_HIDE, WCS_STAR_CONTAINER } from '@/scripts/constants/css-classes'
import PDP from '@/scripts/libs/pdp'
import { GIFTCARDS, RB } from '@/scripts/constants/store'
import { ONE, Y, ZERO } from '@/scripts/constants/booleans'
import makeDebug from 'debug'
import { mapSelectedTryLens, getProductStatusAnalytics } from '@/scripts/libs/products'
import { normalizeProductAvailability } from '@/scripts/normalizer'
import roxConfig from '@/scripts/rox-panel-configuration/rox-config.js'
import { syncAjaxGET } from '../../libs/apple-pay-helpers'
import VirtualMirror from '@/scripts/libs/virtual-mirror/VirtualMirror'
import { WcsCms } from '@/scripts/libs/wcs/cms'
import wcs from '@/scripts/libs/wcs'
import WcsEyemed from '@/scripts/libs/wcs/eyemed'
import { WcsUser } from '@/scripts/libs/wcs/user'
import { WcsPromotions } from '@/scripts/libs/wcs/promotions'
import {
  ADD_PDP_CORRELATED_PRODUCT,
  HIDE_MINICART,
  SET_RXC_SCRIPTS_STATUS,
  SHOW_MINICART,
  TOGGLE_ROX_PANEL,
  UPDATE_FIND_IN_STORE_MODAL,
  UPDATE_FIND_IN_STORE_SELECTED_STORE,
  UPDATE_IMAGES_GALLERY,
  UPDATE_PDP_CAROUSEL,
  UPDATE_PDP_CAROUSEL_LOADING,
  UPDATE_PDP_EYEMED_APPLY_STATUS,
  UPDATE_PDP_PRESCRIPTION_FRAME_CATENTRY,
  UPDATE_PDP_PRESCRIPTION_LENS_CATENTRY,
  UPDATE_PDP_SELECTED_CAT_ENTRY_ID,
  UPDATE_PDP_SELECTED_TRY_LENS,
  UPDATE_PRODUCT_APPLY_BENEFITS,
  UPDATE_PRODUCT_AVAILABILITY,
  UPDATE_SEARCH_STORE_LIST,
  UPDATE_PRODUCT_LOADING,
  HIDE_TRY_LENSES_PANEL,
  SHOW_TRY_LENSES_PANEL,
  SHOW_NEED_HELP_PANEL,
  HIDE_NEED_HELP_PANEL,
  UPDATE_CMS_DYNAMIC_CONTENT,
  UPDATE_EYEMED_STATE,
  STORE_RXC_LENS,
  UPDATE_BREADCRUMBS,
  SET_SELECTED_FACE_SHAPE,
  SET_SIZE_GUIDE_PANEL_TOOGLE,
} from '../mutations/pdp'
import { UPDATE_ROX_PANEL_OVERLAY } from '@/scripts/store/mutations'
import { UPDATE_USER_DATA } from '../mutations'
import Images from '@/scripts/libs/images'
import rbCustomEvent from '@/utils/rb-custom-event'
import { EVENTS } from '@/scripts/constants/css-classes'
export const ACTION_APPLY_EYEMED = 'ACTION_APPLY_EYEMED'
export const ACTION_CHANGE_PRIVATE_SALES_FORMS_STATUS = 'ACTION_CHANGE_PRIVATE_SALES_FORMS_STATUS'
export const ACTION_CHECK_EYEMED_COOKIE = 'ACTION_CHECK_EYEMED_COOKIE'
export const ACTION_FETCH_AND_ADD_CORRELATED_PRODUCT = 'ACTION_FETCH_AND_ADD_CORRELATED_PRODUCT'
export const ACTION_FETCH_AND_ADD_PRODUCT_AVAILABILITY = 'ACTION_FETCH_AND_ADD_PRODUCT_AVAILABILITY'
export const ACTION_FULL_VIEW_ANIMATION_FINISHED = 'ACTION_FULL_VIEW_ANIMATION_FINISHED'
export const ACTION_FULL_VIEW_ANIMATION_START = 'ACTION_FULL_VIEW_ANIMATION_START'
export const ACTION_LOAD_PDP = 'ACTION_LOAD_PDP'
export const ACTION_LOAD_PDP_CAROUSEL = 'ACTION_LOAD_PDP_CAROUSEL'
export const ACTION_LOG_IN = 'ACTION_LOG_IN'
export const ACTION_MAKE_BENEFIT_PRICING_CALL = 'ACTION_MAKE_BENEFIT_PRICING_CALL'
export const ACTION_MAP_CMS_DYNAMIC_CONTENT = 'ACTION_MAP_CMS_DYNAMIC_CONTENT'
export const ACTION_STORE_RXC_LENS = 'ACTION_STORE_RXC_LENS'
export const ACTION_UPDATE_BREADCRUMBS = 'ACTION_UPDATE_BREADCRUMBS'
export const ACTION_PDP_ADD_RELATED_TO_CART = 'ACTION_PDP_ADD_RELATED_TO_CART'
export const ACTION_PDP_HIDE_STICKYBAR_TOOLTIP = 'ACTION_PDP_HIDE_STICKYBAR_TOOLTIP'
export const ACTION_PDP_PRESCRIPTION_FRAME_CATENTRY_UPDATE =
  'ACTION_PDP_PRESCRIPTION_FRAME_CATENTRY_UPDATE'
export const ACTION_PDP_PRESCRIPTION_LENS_CATENTRY_UPDATE =
  'ACTION_PDP_PRESCRIPTION_LENS_CATENTRY_UPDATE'
export const ACTION_PDP_SHOW_STICKYBAR_TOOLTIP = 'ACTION_PDP_SHOW_STICKYBAR_TOOLTIP'
export const ACTION_REFRESH_WISHLIST = 'ACTION_REFRESH_WISHLIST'
export const ACTION_REMOVE_BENEFITS = 'ACTION_REMOVE_BENEFITS'
export const ACTION_SET_FULL_VIEW = 'ACTION_SET_FULL_VIEW'
export const ACTION_SET_RELATED_CATALOG_ENTRIES = 'ACTION_SET_RELATED_CATALOG_ENTRIES'
export const ACTION_SET_SELECTED_SIZE_SKU = 'ACTION_SET_SELECTED_SIZE_SKU'
export const ACTION_SET_UI_POLARIZED = 'ACTION_SET_UI_POLARIZED'
export const ACTION_CLOSE_MINICART = 'ACTION_CLOSE_MINICART'
export const ACTION_OPEN_MINICART = 'ACTION_OPEN_MINICART'
export const ACTION_SMALL_VIEW_ANIMATION_FINISHED = 'ACTION_SMALL_VIEW_ANIMATION_FINISHED'
export const ACTION_SMALL_VIEW_ANIMATION_START = 'ACTION_SMALL_VIEW_ANIMATION_START'
export const ACTION_SUBMIT_EYEMED_FORM = 'ACTION_SUBMIT_EYEMED_FORM'
export const ACTION_TOGGLE_AFTERPAY_MODAL = 'ACTION_TOGGLE_AFTERPAY_MODAL'
export const ACTION_TOGGLE_COMPARE_MODAL = 'ACTION_TOGGLE_COMPARE_MODAL'
export const ACTION_TOGGLE_KLARNA_AFTERPAY_MODAL = 'ACTION_TOGGLE_KLARNA_AFTERPAY_MODAL'
export const ACTION_TOGGLE_POLAR_LENS_UPSELL = 'ACTION_TOGGLE_POLAR_LENS_UPSELL'
export const ACTION_TOGGLE_ROX_PANEL = 'ACTION_TOGGLE_ROX_PANEL'
export const ACTION_CLEAR_ROX_SELECTED_LENSES = 'ACTION_CLEAR_ROX_SELECTED_LENSES'
export const ACTION_SET_RXC_SCRIPTS_STATUS = 'ACTION_SET_RXC_SCRIPTS_STATUS'
export const ACTION_TOGGLE_SIZE_MODAL = 'ACTION_TOGGLE_SIZE_MODAL'
export const ACTION_TRACK_APPLEPAY_CLICK = 'ACTION_TRACK_APPLEPAY_CLICK'
export const ACTION_TRACK_APPLEPAY_ERROR = 'ACTION_TRACK_APPLEPAY_ERROR'
export const ACTION_UPDATE_BAG_QTY = 'ACTION_UPDATE_BAG_QTY'
export const ACTION_UPDATE_BENEFITS = 'ACTION_UPDATE_BENEFITS'
export const ACTION_UPDATE_CMS_CONTENT = 'ACTION_UPDATE_CMS_CONTENT'
export const ACTION_UPDATE_CURRENT_PROMO = 'ACTION_UPDATE_CURRENT_PROMO'
export const ACTION_UPDATE_EYEMED_STATE = 'ACTION_UPDATE_EYEMED_STATE'
export const ACTION_UPDATE_FIND_IN_STORE_MODAL = 'ACTION_UPDATE_FIND_IN_STORE_MODAL'
export const ACTION_UPDATE_FIND_IN_STORE_SELECTED_STORE =
  'ACTION_UPDATE_FIND_IN_STORE_SELECTED_STORE'
export const ACTION_UPDATE_IMAGES_GALLERY_SLIDE_SECTION =
  'ACTION_UPDATE_IMAGES_GALLERY_SLIDE_SECTION'
export const ACTION_UPDATE_IMAGES_GALLERY_SLIDE_INDEX = 'ACTION_UPDATE_IMAGES_GALLERY_SLIDE_INDEX'
export const ACTION_UPDATE_SEARCH_STORE_LIST = 'ACTION_UPDATE_SEARCH_STORE_LIST'
export const ACTION_UPDATE_SELECTED_PRODUCT = 'ACTION_UPDATE_SELECTED_PRODUCT'

export const ACTION_OPEN_TRY_LENSES_PANEL = 'ACTION_OPEN_TRY_LENSES_PANEL'
export const ACTION_CLOSE_TRY_LENSES_PANEL = 'ACTION_CLOSE_TRY_LENSES_PANEL'

export const ACTION_OPEN_NEED_HELP_PANEL = 'ACTION_OPEN_NEED_HELP_PANEL'
export const ACTION_CLOSE_NEED_HELP_PANEL = 'ACTION_CLOSE_NEED_HELP_PANEL'
export const ACTION_SELECTED_FACE_SHAPE_PRODUCT = 'ACTION_SELECTED_FACE_SHAPE_PRODUCT'
export const ACTION_SIZE_GUIDE_PANEL_TOOGLE = 'ACTION_SIZE_GUIDE_PANEL_TOOGLE'

const debug = makeDebug('store:action:pdp')
const ALT_IMAGE_TEXT = 'alt-image-text'

export const actions = {
  [ACTION_UPDATE_BAG_QTY]: () => {
    // TODO: Control this transformations from vue, when this button will be part of vue app
    const element = document.querySelector('button[data-type=bag] .wcs-product-count-circle')
    if (element) {
      element.style.paddingTop = '3px'
      element.innerText = 1
      element.classList.remove(WCS_HIDE)
    }

    sessionStorage.clear()
  },
  [ACTION_REFRESH_WISHLIST]: ({ rootState }) => {
    // TODO: Remove direct dom manipulation and global scope functions call when vue app will have
    // enough control on the page
    const container = document.getElementById(WCS_STAR_CONTAINER)

    if (container) {
      const { storeConfig } = rootState
      const request = syncAjaxGET(
        `${WISHLIST_VIEW}?${STORE_ID}=${storeConfig.storeId}&${CATALOG_ID}=${storeConfig.catalogId}&${LANG_ID}=${storeConfig.langId}`
      )

      container.innerHTML = request.responseText

      window.sidebarHideFavEmptyDiv()
      window.add_product_notification(window.star)
      window.shortlist_tray_length()
      window.custom_scrollable_hover()
      window.scroller()
      window.resize_panel_header_footer()
      window.sharePlus_emailToFriend_bind()
      window.openLinksInNewTab()
    }
  },
  [ACTION_LOAD_PDP]: async (
    { state, commit, dispatch },
    { catEntryId, preventHistory = false } = {}
  ) => {
    debug(ACTION_LOAD_PDP)

    let currentProduct

    if (catEntryId) {
      if (Object.keys(state.correlatedProducts).includes(catEntryId)) {
        currentProduct = state.correlatedProducts[catEntryId]
      } else {
        commit(UPDATE_PRODUCT_LOADING, true)
        commit(ADD_PDP_CORRELATED_PRODUCT, { catEntryId })
        currentProduct = await PDP.fetchPDPDataFromService(catEntryId)
        commit(ADD_PDP_CORRELATED_PRODUCT, currentProduct)
        commit(UPDATE_PRODUCT_LOADING, false)
      }
    } else {
      currentProduct = PDP.getPDPDataFromPage()
      commit(ADD_PDP_CORRELATED_PRODUCT, currentProduct)
      dispatch(ACTION_FETCH_AND_ADD_PRODUCT_AVAILABILITY, currentProduct.catEntryId)
    }

    if (currentProduct?.pageUrl && !preventHistory) {
      const currentUrl = new URL(window.location.href)
      const newUrl = new URL(currentProduct.pageUrl, currentUrl.origin)
      newUrl.search = currentUrl.search
      history.pushState(currentProduct, '', newUrl.href)
    }

    if (currentProduct.catEntryId !== state.selectedCatEntryId) {
      // TODO: put await if there are problems with updating
      commit(UPDATE_PDP_SELECTED_CAT_ENTRY_ID, currentProduct.catEntryId)
    }

    const selectedTryLens = mapSelectedTryLens(
      state?.dataColors?.colors?.carousel,
      currentProduct.catEntryId
    )
    if (selectedTryLens) {
      commit(UPDATE_PDP_SELECTED_TRY_LENS, selectedTryLens)
    }
    if (
      !!currentProduct.type &&
      !GIFTCARDS.map((value) => value.toLowerCase()).includes(currentProduct.type.toLowerCase())
    ) {
      const imagesGallery = await Images.fetchPdpImages({
        altText: currentProduct.altText || ALT_IMAGE_TEXT,
        partNumber: currentProduct.partNumber,
      })

      commit(UPDATE_IMAGES_GALLERY, imagesGallery)
    }
  },
  [ACTION_LOAD_PDP_CAROUSEL]: async ({ commit }, product) => {
    commit(UPDATE_PDP_CAROUSEL_LOADING, true)
    const data = await PDP.fetchCarousel(product)
    commit(UPDATE_PDP_CAROUSEL, { data })
    commit(UPDATE_PDP_CAROUSEL_LOADING, false)
  },
  // TODO: change payload mapping with correct PDP keys
  [ACTION_UPDATE_SELECTED_PRODUCT]: async function ({ getters, dispatch }, payload) {
    const selectedId = payload.id
    const preventHistory = payload?.preventHistory

    await dispatch(ACTION_LOAD_PDP, { catEntryId: selectedId, preventHistory })

    const product = getters.selectedProduct

    await dispatch(ACTION_FETCH_AND_ADD_PRODUCT_AVAILABILITY, selectedId)

    product?.sizes?.forEach(async (size) => {
      await dispatch(ACTION_FETCH_AND_ADD_PRODUCT_AVAILABILITY, size?.catEntryId)
    })

    const isVtoSupportedBrowser = VirtualMirror.isSupportedByBrowser() ? ONE : ZERO
    const priceFormatted = parseFloat(product?.prices?.listPrice).toFixed(2)
    let currentPromoPrice
    if (product.promotions?.length) {
      currentPromoPrice = WcsPromotions.calculatePromotionInProgress(product.promotions)?.price
    }
    this._vm.$ma.trackEvent({
      event: TRACKER_PRODS_CHANGE_UPC,
      value: {
        Vm_IsBrowserSupported: isVtoSupportedBrowser,
        Products: {
          [product?.partNumber]: {
            Status: getProductStatusAnalytics(getters.selectedProductAvailability, product),
            Category: product?.type?.toUpperCase(),
            FrameType: STD,
            Price: currentPromoPrice ?? priceFormatted,
            PriceFull: priceFormatted,
            Brand: RB,
            Size:
              product?.sizes &&
              product?.sizes.length &&
              product?.sizes.find((size) => size.catEntryId === selectedId)?.label,
            Sku: product?.resolvedSkuGridLensBridgeVal,
            ModelName: product?.modelName,
            MoCo: product?.catEntryId,
            Stock: getters.selectedProductAvailability?.inventory,
            Image: product?.imageUrl,
            Url: product?.pageUrl,
            LensColor: product?.features?.lenses?.color,
            LensTechnology: '',
            FrameColor: product?.features?.frame?.color,
            FrameTechnology: product?.features?.frame?.materialPrimary,
            Shape: product?.features?.frame?.shape,
            LensUPC: '',
            ModelCode: '',
            Lens: '',
            Frame: '',
            Case: '',
            Cloth: '',
            Units: '1',
          },
        },
      },
    })
    const { storeId, catalogId, langId } = wcs.getStoreConfig()

    const userCluster = WcsUser.getUserClusterFromWcs()

    const response = await WcsCms.getPdpDynamicContent(
      catalogId,
      storeId,
      langId,
      product.parentCatEntryId,
      userCluster.join(',')
    )
    dispatch(ACTION_MAP_CMS_DYNAMIC_CONTENT, response)
  },
  [ACTION_FETCH_AND_ADD_CORRELATED_PRODUCT]: async ({ commit, state }, catEntryId) => {
    if (!Object.keys(state.correlatedProducts).includes(catEntryId)) {
      commit(ADD_PDP_CORRELATED_PRODUCT, { catEntryId })
      const product = await PDP.fetchPDPDataFromService(catEntryId)
      commit(ADD_PDP_CORRELATED_PRODUCT, product)
    }
  },
  [ACTION_PDP_PRESCRIPTION_LENS_CATENTRY_UPDATE]: function ({ commit }, payload) {
    commit(UPDATE_PDP_PRESCRIPTION_LENS_CATENTRY, payload)
  },
  [ACTION_FETCH_AND_ADD_PRODUCT_AVAILABILITY]: async ({ state, commit }, catEntryId) => {
    if (!Object.keys(state.correlatedProductsAvailability).includes(catEntryId)) {
      commit(UPDATE_PRODUCT_AVAILABILITY, { catEntryId, availability: {} })
      const response = await PDP.fetchAvailabilityData(catEntryId)
      const normalizedAvailability = normalizeProductAvailability(response.availability)
      commit(UPDATE_PRODUCT_AVAILABILITY, { catEntryId, availability: normalizedAvailability })
    }
  },
  [ACTION_APPLY_EYEMED]: function ({ commit }) {
    commit(UPDATE_PDP_EYEMED_APPLY_STATUS, true)
  },
  [ACTION_UPDATE_EYEMED_STATE]: function ({ commit }, payload) {
    debug(ACTION_UPDATE_EYEMED_STATE)
    commit(UPDATE_EYEMED_STATE, payload)
  },
  [ACTION_SUBMIT_EYEMED_FORM]: async function (
    { dispatch, state, getters, rootState },
    postParams
  ) {
    debug(ACTION_SUBMIT_EYEMED_FORM)
    dispatch(ACTION_UPDATE_EYEMED_STATE, { loading: true })
    const pageTypeIns = document.getElementById('pageTypeIns')
    const isRoxEnabled = document.getElementById('isRoxEnabled')

    if (pageTypeIns) {
      postParams.pageTypeIns = pageTypeIns.value
    } else if (isRoxEnabled) {
      postParams.pageTypeIns = 'PDP'
    }
    if (pageTypeIns && pageTypeIns.value === SHOP_CART) {
      const orderId = document.getElementById('OrderId')
      if (orderId && orderId.length !== 0) {
        postParams.orderId = orderId.value
      }
    } else {
      const cartDetails = rootState.sidebar.cart.details
      if (cartDetails && cartDetails.orderId) {
        postParams.orderId = cartDetails.orderId
      }
    }
    const selectedProduct = getters.selectedProduct
    //necessitiamo di catentry del frame e catentry della lente

    if (selectedProduct.type === OPTICAL) {
      if (selectedProduct.roxFrameCatEntryId) {
        postParams.roxFrameCatEntryId = selectedProduct.roxFrameCatEntryId
      }
      if (state.selectedRoxOpticLens) {
        postParams.roxLensCatentryId = state.selectedRoxOpticLens.id
      }
    }

    if (state.eyeMed.fromRoxPanel) {
      const insuranceLoginLoading = roxConfig.insuranceModule.getEvents().INSURANCE_LOGIN_LOADING
      window.dispatchEvent(new CustomEvent(insuranceLoginLoading))
    }

    const result = await WcsEyemed.submitEyeMedForm(postParams, state.eyeMed.fromRoxPanel)
    debug('EyeMed form answered with this result: %o', result)
    dispatch(ACTION_UPDATE_EYEMED_STATE, { ...result, loading: false })
    // DISABLE APPLE PAY
    const applePayEnabled = document.getElementById('applePayEnabled')
    if (applePayEnabled && applePayEnabled.value === Y) {
      const applePayEnabledInPDP = document.getElementById('applePayEnabledInPDP')
      const applePayEnabledInPCP = document.getElementById('applePayEnabledInPCP')
      if (
        (applePayEnabledInPDP && applePayEnabledInPDP.value === Y) ||
        (applePayEnabledInPCP && applePayEnabledInPCP.value === Y)
      ) {
        if (window.applePayDesktopInst !== undefined) {
          window.applePayDesktopInst.hideApplePayButtons()
        }
      }
    }

    if (result.success && postParams.pageTypeIns !== SHOP_CART && !state.eyeMed.fromRoxPanel) {
      const roxLensCatentryId = postParams.roxLensCatentryId
      const roxFrameCatentryId = postParams.roxFrameCatEntryId
      dispatch(ACTION_MAKE_BENEFIT_PRICING_CALL, { roxFrameCatentryId, roxLensCatentryId })
    }
  },
  [ACTION_MAKE_BENEFIT_PRICING_CALL]: async function (
    { dispatch, commit },
    { roxFrameCatentryId, roxLensCatentryId }
  ) {
    const postParams = {
      pageTypeIns: 'PDP',
      roxLensCatentryId: roxLensCatentryId,
      roxFrameCatentryId: roxFrameCatentryId,
    }
    const result = await WcsEyemed.makeBenefitPricingCall(postParams)
    if (result.error) {
      dispatch(ACTION_UPDATE_EYEMED_STATE, { error: true, success: false, applied: false })
    } else if (result.success) {
      commit(UPDATE_PRODUCT_APPLY_BENEFITS, result)
    }
  },
  [ACTION_UPDATE_BENEFITS]: function ({ commit }, payload) {
    commit(UPDATE_PRODUCT_APPLY_BENEFITS, payload)
  },
  [ACTION_REMOVE_BENEFITS]: function ({ dispatch }) {
    dispatch(ACTION_UPDATE_BENEFITS, undefined)
  },
  [ACTION_CHECK_EYEMED_COOKIE]: function ({ dispatch }) {
    debug(ACTION_CHECK_EYEMED_COOKIE)
    const isEyemedLoggedIn = WcsEyemed.isUserLoggedIn()
    if (isEyemedLoggedIn) {
      dispatch(ACTION_UPDATE_EYEMED_STATE, { applied: true })
    }
  },
  [ACTION_LOG_IN]: function ({ commit }) {
    debug(ACTION_LOG_IN)
    commit(
      UPDATE_USER_DATA,
      {
        logged: true,
      },
      { root: true }
    )
  },
  [ACTION_TRACK_APPLEPAY_CLICK]: function ({ getters }) {
    debug(ACTION_TRACK_APPLEPAY_CLICK)

    const product = getters.selectedProduct
    const MoCo = product?.productId
    this._vm.$ma.trackEvent({
      event: TRACKER_CHECKOUT_STEP_GATEWAY,
      value: {
        Products: {
          [product?.partNumber]: {
            Status: product?.status,
            Category: product?.type?.toUpperCase(),
            Price: product?.offerPrice,
            PriceFull: product?.offerPrice,
            Brand: RB,
            Size: product?.sizes?.filter((size) => size.active === true).label,
            Sku: product?.resolvedSkuGridLensBridgeVal,
            ModelName: product?.modelName,
            MoCo: MoCo,
            Stock: `${product?.inventory}`,
            Image: product?.imageUrl,
            Url: product?.pageUrl,
            LensColor: product?.lensColor,
            LensTechnology: '',
            FrameColor: product?.frameColor,
            FrameTechnology: product?.features?.frame?.materialPrimary,
            Shape: product?.features?.frame?.shape,
            LensUPC: '',
            ModelCode: '',
            Lens: '',
            Frame: '',
            Case: '',
            Cloth: '',
            Units: '1',
          },
        },
        Order_PaymentType: 'ApplePayExpressCheckout',
      },
    })
  },
  [ACTION_TRACK_APPLEPAY_ERROR]: function (_, payload) {
    this._vm.$ma.trackEvent({
      event: 'Error',
      value: {
        Error_Source: TRACKER_ERROR_SOURCE_SERVER,
        Error_Code: 'Checkout Payment Gateway - ' + payload,
        Error_Detail: 'ApplePay',
      },
    })
  },
  [ACTION_UPDATE_FIND_IN_STORE_MODAL]: function ({ commit }, payload) {
    debug(ACTION_UPDATE_FIND_IN_STORE_MODAL)
    commit(UPDATE_FIND_IN_STORE_MODAL, payload)
  },
  [ACTION_UPDATE_SEARCH_STORE_LIST]: function ({ commit }, payload) {
    debug(ACTION_UPDATE_SEARCH_STORE_LIST)
    commit(UPDATE_SEARCH_STORE_LIST, payload)
  },
  [ACTION_UPDATE_FIND_IN_STORE_SELECTED_STORE]: function ({ commit }, payload) {
    debug(ACTION_UPDATE_FIND_IN_STORE_SELECTED_STORE)
    commit(UPDATE_FIND_IN_STORE_SELECTED_STORE, payload)
  },
  [ACTION_TOGGLE_ROX_PANEL]: function ({ commit }, payload) {
    commit(
      UPDATE_ROX_PANEL_OVERLAY,
      {
        roxPanelOverlay: payload.roxPanelOverlay,
        roxPanelOverlayType: payload.roxPanelOverlayType,
      },
      { root: true }
    )

    commit(TOGGLE_ROX_PANEL, payload.isRoxPanelRendered)

    if (!payload.isRoxPanelRendered) {
      rbCustomEvent(EVENTS.TOOGLE_HEADER, {
        detail: {
          display: true,
        },
      })
    } else {
      rbCustomEvent(EVENTS.TOOGLE_HEADER, {
        detail: {
          display: false,
        },
      })
    }
  },
  [ACTION_CLEAR_ROX_SELECTED_LENSES]: ({ dispatch }) => {
    dispatch(ACTION_PDP_PRESCRIPTION_LENS_CATENTRY_UPDATE, undefined)
    dispatch(ACTION_PDP_PRESCRIPTION_FRAME_CATENTRY_UPDATE, undefined)
  },
  [ACTION_SET_RXC_SCRIPTS_STATUS]: function ({ commit }, payload) {
    commit(SET_RXC_SCRIPTS_STATUS, payload)
  },
  [ACTION_PDP_PRESCRIPTION_FRAME_CATENTRY_UPDATE]: function ({ commit }, payload) {
    commit(UPDATE_PDP_PRESCRIPTION_FRAME_CATENTRY, payload)
  },
  [ACTION_OPEN_MINICART]: function ({ commit, getters }) {
    const product = getters.selectedProduct
    this._vm.$ma.trackEvent({
      event: TRACK_MINI_CART_OVERLAY_OPEN,
      value: {
        Products: {
          [product?.partNumber]: {
            Status: getProductStatusAnalytics(getters.selectedProductAvailability, product),
            Category: product?.type?.toUpperCase(),
            FrameType: STD,
            Price: product?.prices?.listPrice,
            PriceFull: product?.prices?.listPrice,
            Engraving: '',
            Brand: RB,
            Sku: product?.resolvedSkuGridLensBridgeVal,
            ModelName: product?.modelName,
            LensTechnology: product?.features?.lenses?.description,
            FrameTechnology: product?.features?.frame?.materialPrimary,
            Shape: product?.features?.frame?.shape,
            LensUPC: '',
            ModelCode: product?.modelCode,
            Units: ONE,
          },
        },
      },
    })
    commit(SHOW_MINICART)
  },
  [ACTION_CLOSE_MINICART]: function ({ commit }) {
    commit(HIDE_MINICART)
  },
  [ACTION_OPEN_TRY_LENSES_PANEL]: function ({ commit }) {
    commit(SHOW_TRY_LENSES_PANEL)
  },
  [ACTION_CLOSE_TRY_LENSES_PANEL]: function ({ commit }) {
    commit(HIDE_TRY_LENSES_PANEL)
  },
  [ACTION_OPEN_NEED_HELP_PANEL]: function ({ commit }) {
    commit(SHOW_NEED_HELP_PANEL)
  },
  [ACTION_CLOSE_NEED_HELP_PANEL]: function ({ commit }) {
    commit(HIDE_NEED_HELP_PANEL)
  },
  [ACTION_MAP_CMS_DYNAMIC_CONTENT]: function ({ commit }, payload) {
    commit(UPDATE_CMS_DYNAMIC_CONTENT, payload)
  },
  [ACTION_STORE_RXC_LENS]: function ({ commit }, payload) {
    commit(STORE_RXC_LENS, payload)
  },
  [ACTION_UPDATE_BREADCRUMBS]: function ({ commit }, payload) {
    commit(UPDATE_BREADCRUMBS, payload)
  },
  [ACTION_SELECTED_FACE_SHAPE_PRODUCT]: function ({ commit }, payload) {
    commit(SET_SELECTED_FACE_SHAPE, payload)
  },
  [ACTION_SIZE_GUIDE_PANEL_TOOGLE]: function ({ commit }, payload) {
    commit(SET_SIZE_GUIDE_PANEL_TOOGLE, payload)
  },
}
